export const PREFIX_BS = 'bs-';
//# sourceMappingURL=config.js.map